import {
  Box,
  Typography,
} from '@mui/material';
import { T, Icon } from '../parts/stitch';
import QuitclaimCard from '../parts/QuitclaimCard';
import { useProjectData } from '../ProjectDataContext';

function QuitclaimsPanel() {
  const {
    quitclaims,
  } = useProjectData();

  return (
    <>
        {quitclaims.length === 0 ? (
          <Box sx={{ textAlign: 'center', py: 6 }}>
            <Icon name="description" size={48} sx={{ color: T.outlineVariant, display: 'block', mx: 'auto', mb: 1 }} />
            <Typography sx={{ fontFamily: T.fontBody, color: T.outline }}>Geen quitclaims gevonden</Typography>
          </Box>
        ) : (
          <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' } }}>
            {quitclaims.map((qc) => <QuitclaimCard key={qc.id} quitclaim={qc} />)}
          </Box>
        )}
    </>
  );
}

export default QuitclaimsPanel;
